function controller(
  $scope, $filter, $location, $routeParams, Transfer, EFTRequests, InvestmentAccountTransfersIn, BankingInfo, brand, Config, locale) {
  let userId = $routeParams.clientId;
  const isAdmin = !!$routeParams.clientId;
  const userDate = moment().format()

  const isNewTransferPage = $location.path().split('/').includes('transfers-eft');
  const transferSource = isNewTransferPage ? EFTRequests : Transfer;

  if (userId) {
    userId = parseInt(userId, 10);
  } else {
    userId = $scope.$root.auth.currentUser.id;
  }

  $scope.brandFullName = locale.isFrench() ? brand.getLocalizedBrandFullNames().fr : brand.getLocalizedBrandFullNames().en;

  $scope.categories = {
    isNew: ({ category, status } = {}) => category === undefined || status === 'transfer_change_requested',
    isDeposit: ({ category } = {}) => category === 'deposit',
    isTransfer: ({ category } = {}) => category === 'transfer',
    isWithdrawal: ({ category } = {}) => category === 'withdrawal' || category === 'withdrawal_all',
    isRecurring: ({ frequency } = {}) => frequency > 0,
  };

  function setupDetails() {
    if ($location.search().category) {
      $scope.transfer.category = $location.search().category;
    }
    if ($location.search().investmentAccountId) {
      const accountId = parseInt($location.search().investmentAccountId, 10);
      $scope.transfer.investmentAccountId = accountId;
      return accountId;
    }
    $scope.setDefaultInvestmentAccount();
    return null;
  }

  function setupTransfer() {
    if ($location.search().id) {
      return transferSource.get({ id: $location.search().id }, transfer => {
        $scope.transfer = transfer;
        return setupDetails();
      });
    }

    if (!$scope.transfer || $location.url() === $location.path()) {
      let iid;
      if ($scope.accounts && $scope.accounts.length > 0) {
        iid = $scope.accounts[0].id;
      } else {
        iid = null;
      }
      $scope.transfer = {
        userId,
        investmentAccountId: iid,
      };
    }
    return setupDetails();
  }

  function checkIfAccountHasWithdrawalsInFlight(account, transfers) {
    for (const transfer of transfers) {
      if (account.id === transfer.investmentAccountId) {
        return transfer.targetAccountHasWithdrawalsInFlight;
      }
    }
    return false;
  }

  function fetchTransfers() {
    $scope.loading = true;
    return transferSource.query({ userId, userDate }, (transfers) => {
      $scope.loading = false;
      $scope.transfers = transfers;
      $scope.accounts.forEach((account) => {
        account.hasWithdrawalsInFlight = checkIfAccountHasWithdrawalsInFlight(account, transfers);
      });
      return transfers;
    });
  }

  $scope.$on('$locationChangeStart', setupTransfer);

  BankingInfo.get({ userId }, (accounts) => {
    accounts.investmentAccounts.forEach((account) => {
      account.displayText = `${account.name ? account.name : account.accountTypeName} ${isAdmin ? `#${account.accountIdentifier}` : ''}`;
      return account.displayText;
    });
    $scope.accounts = accounts.investmentAccounts;
    $scope.setDefaultInvestmentAccount();
    return fetchTransfers();
  });

  $scope.setDefaultInvestmentAccount = () => {
    const id = $scope.accounts && $scope.accounts.length === 1 ? $scope.accounts[0].id : '';
    $scope.transfer.investmentAccountId = id;
  };

  $scope.back = () => $location.url($location.path());

  $scope.setCategory = (category) => {
    $scope.transfer = undefined;
    return $location.search('category', category);
  };

  $scope.goToAccountTransfer = () => {
    let urlParams = '';
    if ($routeParams.clientId) {
      urlParams = `?user_id=${$routeParams.clientId}`;
    }
    window.location.href = `/app/transfers/account-transfer${urlParams}`;
  };

  $scope.selectAccount = () => $location.search('investmentAccountId', $scope.transfer.investmentAccountId);

  $scope.transferSubmitted = () => {
    $scope.transferDialog.hide();
    return $location.url($location.path());
  };

  $scope.cancelTransfer = (transfer) => {
    $scope.activeTransfer = transfer;
    return $scope.transferCancelDialog.show();
  };

  const identifyTransferCategory = ({ category }) => {
    if (category === 'transfer') { return InvestmentAccountTransfersIn; }
    return Transfer;
  };

  $scope.cancelActive = () => {
    $scope.cancelClicked = true;
    if (isNewTransferPage) {
      transferSource.delete({ id: $scope.activeTransfer.id, userId: userId, category: $scope.activeTransfer.category}, (result) => {
        fetchTransfers();
        $scope.activeTransfer.status = result.status;
        $scope.transferFormDelete.$setPristine();
        $scope.transferCancelDialog.hide();
        $scope.transferCancelDialogConfirmed.show();
      });
    } else {
      identifyTransferCategory($scope.activeTransfer)
      .get({ id: $scope.activeTransfer.id }, (transfer) => {
        if (transfer.status === 'requested' || 'active' || 'in_progress' || 'uploaded' || 'edit_requested' || 'queued' || 'needs_attention') {
          transfer.$delete()
          .then((({ status }) => {
            fetchTransfers();
            $scope.activeTransfer.status = status;
            $scope.transferFormDelete.$setPristine();
            $scope.transferCancelDialog.hide();
            $scope.transferCancelDialogConfirmed.show();
          }))
          .catch((err) => {
            fetchTransfers();
            $scope.activeTransfer.status = err.status;
            $scope.transferCancelDialog.hide();
            $scope.transferCancelDialogError.show()
          });
        } else {
          $scope.transferCancelDialog.hide();
          $scope.transferCancelDialogError.show();
        }
        $scope.cancelClicked = false;
      });
    }
  };

  $scope.request = () => {
    $scope.error = null;
    $scope.accountName = $scope.accounts.find(
      account => account.id === $scope.transfer.investmentAccountId,
    ).displayText.trim();
    return $scope.transferConfirmDialog.show();
  };

  $scope.accountById = (id) => $scope.accounts.find(a => a.id === id);

  $scope.confirmTransfer = () => {
    $scope.error = null;
    delete $scope.transfer.id;

    const transfer = Object.assign({}, $scope.transfer);

    if (transfer.frequency === undefined || transfer.frequency === null) {
      transfer.frequency = 0;
    }
    if (transfer.transferAt) {
      transfer.transferAt = transfer.transferAt.toDate();
    }
    transferSource.create(
      transfer,
      () => {
        $scope.transferConfirmDialog.hide();
        $scope.transferForm.$setDirty();
        $scope.transferForm.$setPristine();
        $scope.transferDialog.show();
        return fetchTransfers();
      },
      (error) => {
        $scope.transferForm.$setPristine();
        $scope.error = error.data.errorMessages[0];
      },
    );
  };

  $scope.resetTableData = () => fetchTransfers();
  $scope.isNearTransferAt = date => moment().diff(date, 'days') * -1 <= 10;


  Config.get(({transfers}) => $scope.transfersConfig = transfers)
  setupTransfer();

  return $scope;
}

export default [
  '$scope',
  '$filter',
  '$location',
  '$routeParams',
  'Transfer',
  'EFTRequests',
  'InvestmentAccountTransfersIn',
  'BankingInfo',
  'brand',
  'Config',
  'locale',
  controller,
];
